import { ApprovalStatusController } from './approval-status.controller'

function approvalStatus () {
  return {
    restrict: 'E',
    scope: {
      type: '<',
      noBackground: '<',
      reverse: '<',
      darkMode: '<'
    },
    templateUrl: '/workflow/directives/approval-status/approval-status.html?$$REVISION$$',
    controller: ApprovalStatusController
  }
}

export { approvalStatus }
